<template>
  <!-- Start Skeleton Service  -->
  <div class="row mt_dec--30" v-if="store.loading">
    <v-row>
      <v-col cols="12" sm="6" :md="comNumColumnas" class="mt--30" v-for="n in 6" :key="'service-skeleton-' + n">
        <div class="single-service service__style-notin bg-color-gray border-0 elevation-0" style="background: transparent !important;">
          <v-skeleton-loader
            type="heading, paragraph"
            :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"
            class="rounded-lg pa-4"
          ></v-skeleton-loader>
        </div>
      </v-col>
    </v-row>
  </div>
  <!-- End Skeleton Service  -->

  <!-- Start Search Area -->
  <v-row v-if="!props.Home && NOTARIA && !store.loading && store.NOTARIA?.Theme?.Servicios?.MostrarBuscador !== false" class="mb-4 justify-center">
    <v-col cols="12" md="8" lg="6">
      <v-text-field
        v-model="searchQuery"
        prepend-inner-icon="mdi-magnify"
        label="Buscar servicio..."
        variant="outlined"
        density="comfortable"
        hide-details
        clearable
        class="search-bar-notin"
      ></v-text-field>
    </v-col>
  </v-row>
  <v-row v-if="!props.Home && searchQuery.trim() !== '' && store.NOTARIA?.Personalizar?.ChatbotActivo && !store.chatbotOverQuota" class="mb-5 justify-center">
    <v-col cols="12" class="text-center">
      <v-btn
        :color="store.NOTARIA?.Personalizar?.ChatbotColor || 'primary'"
        variant="outlined"
        prepend-icon="mdi-robot-outline"
        @click="askAi"
        class="mt-2 text-none"
      >
        Preguntar a la Inteligencia Artificial sobre '{{ searchQuery }}'
      </v-btn>
    </v-col>
  </v-row>
  <v-row v-if="!props.Home && searchQuery.trim() !== '' && serviciosPublicados().length === 0" class="mb-5 justify-center">
    <v-col cols="12" class="text-center text-muted">
      <p>No se han encontrado servicios que coincidan con la búsqueda.</p>
    </v-col>
  </v-row>
  <!-- End Search Area -->

  <!-- Start Single Service  -->
  <div class="row mt_dec--30" v-if="!store.loading">
    <v-row v-if="isModerno" class="row-gap-30">
      <v-col
        cols="12"
        sm="6"
        :md="comNumColumnas"
        v-for="(service, i) in serviciosPublicados()"
        :key="service.Slug || i"
        class="d-flex"
      >
        <NuxtLink
          :to="langPath + '/servicios/' + service.Slug + (Home ? '?from=home' : '')"
          class="modern-service-link w-100"
        >
          <div class="modern-service-card d-flex flex-column fill-height" :style="{ background: tarjetaBackgroundStyle || '' }">
            <!-- Glow aura backdrop on hover -->
            <div class="card-glow-aura" :style="{ background: 'radial-gradient(circle at top right, ' + (estiloTarjetaTituloColor || '#3949ab') + '15, transparent 60%)' }"></div>
            
            <!-- Icon/Badge container -->
            <div v-if="showIcons" class="icon-container mb-6 d-flex align-center justify-center" :style="{ color: estiloTarjetaTituloColor || '#3949ab', '--icon-hover-bg': estiloTarjetaTituloColor || '#3949ab' }">
              <v-icon class="modern-service-icon" large>{{ getServiceIcon(service) }}</v-icon>
            </div>

            <!-- Content -->
            <div class="card-content d-flex flex-column flex-grow-1">
              <h3 class="modern-card-title mb-3" :style="tarjetaTituloStyle">
                {{ service.Titulo }}
              </h3>
              <p class="modern-card-description flex-grow-1" :style="tarjetaDescripcionStyle">
                {{ service.Extracto }}
              </p>
            </div>
          </div>
        </NuxtLink>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" sm="6" :md="comNumColumnas" class="mt--30" v-for="(service, i) in serviciosPublicados()" :key="i">
        <div :class="'single-service service__style-notin bg-color-gray card-' + type + '-notin'">
          <NuxtLink :to="langPath+'/servicios/' + service.Slug + (Home ? '?from=home' : '')">
            <div class="service">
              <div class="content">
                <!-- Icon container in classic card if showIcons is enabled -->
                <div v-if="showIcons" class="classic-service-icon-container mb-4">
                  <v-icon class="classic-service-icon" large>{{ getServiceIcon(service) }}</v-icon>
                </div>
                <h3 class="heading-title">
                  {{ service.Titulo }}
                </h3>
                <p>
                  {{ service.Extracto }}
                </p>
              </div>
            </div>
          </NuxtLink>
        </div>
      </v-col>
    </v-row>
  </div>
  <!-- End Single Service  -->
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { useStore } from '../../store/index'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()

import { useStyles } from '../../store/styles';
const style = useStyles();
const props = defineProps({
  Home: Boolean,
  type: String
})
const langPath = computed(()=>{
  const firstLang = store.languages && store.languages.length > 0 ? store.languages[0].Language : 'es';
  if (NOTARIA.value?.Languaje == firstLang) return '';
  return '/' + NOTARIA.value?.Languaje;
})
const comNumColumnas = computed(() => {
  const theme = NOTARIA.value?.Theme
  if (!theme) return 4
  
  const cols = props.Home ? theme.Home?.Servicios?.NumeroColumnas : theme.Servicios?.NumeroColumnas
  
  const c = Number(cols)
  if (c === 1) return 12
  if (c === 2) return 6
  if (c === 3) return 4
  if (c === 4) return 3
  
  return 4 // Por defecto 3 columnas (col-4)
})

const searchQuery = ref('');

const askAi = () => {
    store.pendingChatQuery = searchQuery.value;
    store.isChatbotOpen = true;
};

function serviciosPublicados(){
  let list = [];
  if(props.Home)
  {
    list = NOTARIA.value?.Servicios.filter(s=>s.Publicado && s.MostrarHome) || [];
  }else{
    list = NOTARIA.value?.Servicios.filter(s=>s.Publicado && (s.MostrarEnSeccion || s.MostrarEnSeccion != false)) || [];
  }
  
  if (searchQuery.value.trim() !== '') {
    const q = searchQuery.value.toLowerCase();
    list = list.filter(s => 
      (s.Titulo && s.Titulo.toLowerCase().includes(q)) || 
      (s.Extracto && s.Extracto.toLowerCase().includes(q))
    );
  }
  return list;
}

const estiloTarjetaTituloColor = computed(() => style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.Color)
const estiloTarjetaTituloShadow = computed(() => {
    const bg = style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.BackgroundColor;
    return (bg && bg !== 'transparent' && bg !== '#00000000' && bg !== '#0000') ? "4px 2px 6px " + bg : "none";
})
const estiloTarjetaTituloFont = computed(() => style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.Font)
const estiloTarjetaTituloSize = computed(() => style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.Size)
const estiloTarjetaTituloWeight = computed(() => style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.Weight)
const estiloTarjetaTituloAlign = computed(() => style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.Align)

const estiloTarjetaDescripcionColor = computed(() => style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.Color)
const estiloTarjetaDescripcionShadow = computed(() => {
    const bg = style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.BackgroundColor;
    return (bg && bg !== 'transparent' && bg !== '#00000000' && bg !== '#0000') ? "4px 2px 6px " + bg : "none";
})
const estiloTarjetaDescripcionFont = computed(() => style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.Font)
const estiloTarjetaDescripcionSize = computed(() => style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.Size)
const estiloTarjetaDescripcionWeight = computed(() => style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.Weight)
const estiloTarjetaDescripcionAlign = computed(() => style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.Align)

const estiloTarjetaFondoColor = computed(() => {
  const fondo = style.ThemeSectionServicios?.Tarjeta?.FondoCSS;
  if(fondo?.BackgroundColorGradient){
    return "linear-gradient(to right," + (fondo.BackgroundColor || 'transparent') + "," + fondo.BackgroundColorGradient + ")"
  }
  return fondo?.BackgroundColor || 'transparent'
})

// Configuración de estilo moderno general, ref: https://trello.com/c/a7FsOrSL
const showIcons = computed(() => {
  if (props.Home) {
    return NOTARIA.value?.Theme?.Home?.Servicios?.ShowIcons !== false;
  }
  return NOTARIA.value?.Theme?.Servicios?.ShowIcons !== false;
})

const isModerno = computed(() => {
  if (props.Home) {
    return NOTARIA.value?.Theme?.Home?.Servicios?.Design === 1;
  }
  // Las tarjetas tienen su propio diseño; sin él, siguen al de la cabecera (ref: https://trello.com/c/yOKIgWPT)
  const servicios = NOTARIA.value?.Theme?.Servicios;
  return (servicios?.TipoTarjetas || servicios?.Tipo) === 'moderno';
})

const tarjetaTituloStyle = computed(() => ({
  color: style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.Color ?? '',
  textShadow: estiloTarjetaTituloShadow.value,
  fontFamily: style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.Font ?? '',
  fontSize: style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.Size ?? '',
  fontWeight: style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.Weight ?? '',
  textAlign: style.ThemeSectionServicios?.Tarjeta?.Titulo?.css?.Align ?? 'left'
}))

const tarjetaDescripcionStyle = computed(() => ({
  color: style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.Color ?? '',
  textShadow: estiloTarjetaDescripcionShadow.value,
  fontFamily: style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.Font ?? '',
  fontSize: style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.Size ?? '',
  fontWeight: style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.Weight ?? '',
  textAlign: style.ThemeSectionServicios?.Tarjeta?.Descripcion?.css?.Align ?? 'left'
}))

const tarjetaBackgroundStyle = computed(() => {
  const fondo = style.ThemeSectionServicios?.Tarjeta?.FondoCSS;
  if (fondo && (fondo.BackgroundColor || fondo.BackgroundColorGradient)) {
    if (fondo.BackgroundColorGradient) {
      return `linear-gradient(135deg, ${fondo.BackgroundColor || '#ffffff'} 0%, ${fondo.BackgroundColorGradient} 100%)`;
    }
    return fondo.BackgroundColor;
  }
  return '';
})

// List of professional notary icons matched automatically based on title
const getServiceIcon = (service) => {
  if (service && service.Icon && service.Icon.trim() !== '') {
    return service.Icon;
  }
  const title = service ? service.Titulo : '';
  const t = (title || '').toLowerCase();
  if (t.includes('herencia') || t.includes('testamento') || t.includes('sucesion') || t.includes('sucesores') || t.includes('herederos') || t.includes('fallecimiento') || t.includes('declaracion')) {
    return 'mdi-file-sign'; // Inheritance / Will
  }
  if (t.includes('compraventa') || t.includes('vivienda') || t.includes('inmobiliaria') || t.includes('hipoteca') || t.includes('propiedad') || t.includes('piso') || t.includes('casa') || t.includes('finca') || t.includes('obra nueva')) {
    return 'mdi-home-city-outline'; // Property Sales / Mortgages
  }
  if (t.includes('poder') || t.includes('poderes') || t.includes('autorizacion') || t.includes('representacion')) {
    return 'mdi-file-certificate-outline'; // Powers of Attorney
  }
  if (t.includes('empresa') || t.includes('sociedad') || t.includes('sociedades') || t.includes('mercantil') || t.includes('constitu') || t.includes('accionistas') || t.includes('pact')) {
    return 'mdi-office-building-cog'; // Companies / Corporate
  }
  if (t.includes('boda') || t.includes('matrimonio') || t.includes('divorcio') || t.includes('pareja') || t.includes('separacion') || t.includes('capitulac')) {
    return 'mdi-cards-heart-outline'; // Marriage / Family Law
  }
  if (t.includes('acta') || t.includes('actas') || t.includes('notarial') || t.includes('presencia') || t.includes('requerimiento') || t.includes('notifica')) {
    return 'mdi-clipboard-text-outline'; // Notarial Minutes / Acts
  }
  if (t.includes('prestamo') || t.includes('credito') || t.includes('aval') || t.includes('deuda') || t.includes('poliza') || t.includes('póliza')) {
    return 'mdi-cash-multiple'; // Loans / Financial
  }
  if (t.includes('firma') || t.includes('legitimacion') || t.includes('copia') || t.includes('testimonio')) {
    return 'mdi-draw-pen'; // Signature verification
  }
  // Fallback icon
  return 'mdi-shield-check-outline';
};
</script>
<style lang="scss">

  .card-servicios-notin h3, .card-servicios-notin h5{
    color:v-bind(estiloTarjetaTituloColor)  !important;
    text-shadow:v-bind(estiloTarjetaTituloShadow)  !important;
    font-size:v-bind(estiloTarjetaTituloSize) !important;
    font-family: v-bind(estiloTarjetaTituloFont) !important;
    font-weight:v-bind(estiloTarjetaTituloWeight) !important;
    text-align:v-bind(estiloTarjetaTituloAlign)  !important;
    width: 100% !important;
  }

  .card-servicios-notin p{
    color:v-bind(estiloTarjetaDescripcionColor)  !important;
    text-shadow:v-bind(estiloTarjetaDescripcionShadow)  !important;
    font-family:v-bind(estiloTarjetaDescripcionFont)  !important;
    font-size: v-bind(estiloTarjetaDescripcionSize) !important;
    font-weight:v-bind(estiloTarjetaDescripcionWeight) !important;
    text-align:v-bind(estiloTarjetaDescripcionAlign)  !important;
    width: 100% !important;
  }
  .card-servicios-notin a, .card-servicios-notin .service, .card-servicios-notin .content{
    width: 100% !important;
    display: block !important;
  }
  .card-servicios-notin a:before{
    background:v-bind(estiloTarjetaFondoColor)  !important;
  }

  /* Classic Card Icons Styles */
  .classic-service-icon-container {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    
    .classic-service-icon {
      color: v-bind(estiloTarjetaTituloColor) !important;
      font-size: 2.5rem !important;
      opacity: 0.85;
      transition: opacity 0.3s ease, transform 0.3s ease;
    }
  }

  .single-service:hover {
    .classic-service-icon-container {
      transform: translateY(-2px) scale(1.08);
      
      .classic-service-icon {
        opacity: 1;
      }
    }
  }

  /* Modern Card Design Rules */
  .modern-service-link {
    text-decoration: none !important;
    color: inherit !important;
  }

  .modern-service-card {
    position: relative;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 24px;
    padding: 40px 30px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    overflow: hidden;
    z-index: 1;
    width: 100%;

    .card-glow-aura {
      position: absolute;
      inset: 0;
      opacity: 0;
      transition: opacity 0.4s ease;
      z-index: -1;
    }

    .icon-container {
      width: 64px;
      height: 64px;
      background: rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      transition: all 0.4s ease;
      
      .modern-service-icon {
        transition: transform 0.4s ease;
        color: inherit !important;
      }
    }

    .modern-card-title {
      font-size: 1.35rem;
      font-weight: 700;
      line-height: 1.4;
    }

    .modern-card-description {
      font-size: 0.95rem;
      line-height: 1.6;
      color: #64748b;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
      border-color: rgba(0, 0, 0, 0.12);

      .card-glow-aura {
        opacity: 1;
      }

      .icon-container {
        background: var(--icon-hover-bg, #3949ab) !important;
        color: #ffffff !important;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
      }

      .modern-service-icon {
        transform: scale(1.1);
      }
    }
  }

  @media (max-width: 600px) {
    .modern-service-card {
      padding: 30px 20px;
    }
  }
</style>